import { createReducer, on } from '@ngrx/store';
import * as UserDetailsActions from '../actions/user-details.actions';
import { UserDetails } from 'src/app/shared/models/portalService';
import { Terms } from 'src/app/shared/models';

export interface UserDetailsState {
  userDetails: UserDetails;
  terms: Terms;
  loading: boolean;
  error: Error;
}

export const initialState: UserDetailsState = {
  userDetails: undefined,
  terms: undefined,
  loading: false,
  error: undefined,
};

export const reducer = createReducer(
  initialState,
  on(UserDetailsActions.setUserDetails, (state, action) => ({
    ...state,
    userDetails: action.userDetails,
  })),
  on(UserDetailsActions.setTerms, (state, action) => ({
    ...state,
    terms: action.terms,
  })),
  on(UserDetailsActions.clearUserDetailsState, () => ({
    ...initialState,
  })),
);
